import EntityDateblock from "entity-app/shared-components/entity-dateblock";
import {
  TFeatureWorkflowInstance,
  TFetureDetailUpdateAction
} from "entity-app/models";
import EntityRiskStatementView from "entity-app/shared-components/entity-dateblock/components/entity-risk-statement/entity-risk-statement-view";
import FeatureToFeatureLinksViewPanel from "components/feature-to-feature-links-view-panel";
import ErrorBoundary from "components/error-boundary";
import BidPackagePlanPanel from "components/bid-package-plan-panel";
import { Card } from "antd";
import { FeatureTypes } from "entity-app/constants";
import { TGoverningSource } from "entity-app/shared-components/entity-dateblock/models";
import { useContext, useMemo, useState } from "react";
import { ProjectContext } from "context/ProjectProvider";
import { getTypeOfGoverningSourceTitle } from "entity-app/utils/utils";
import ProjectWorkflowTemplateDropdown from "../workflow-template-dropdown";

function HeadingDateBlock(props: {
  featureInstanceData: any;
  actions: TFetureDetailUpdateAction;
  disable: boolean;
  setTempDisable: (isLoading: boolean) => void;
}) {
  const { featureInstanceData, actions, disable, setTempDisable } = props;
  if (!featureInstanceData) return null;
  const { feature_workflow_instance: featureWorkflowInstance } =
    featureInstanceData as {
      feature_workflow_instance: TFeatureWorkflowInstance;
    };

  return (
    <div className="flex w-full items-center space-x-4">
      <div className="flex items-center">
        <div>Bid Package Schedule</div>
        <div className="pl-8 text-ciq-gray-800 text-opacity-80">
          <EntityRiskStatementView
            actions={actions}
            featureWorkflowInstance={featureWorkflowInstance}
          />
        </div>
      </div>

      <div className="flex items-center space-x-1 font-medium">
        <div className="text-xs font-medium">Template:</div>
        <ProjectWorkflowTemplateDropdown
          afterChange={() => {
            actions.refetchFeatureInstanceData();
          }}
          featureId={FeatureTypes.BID_PACKAGE}
          featureWorkflowInstance={featureWorkflowInstance}
          disable={disable}
          setApiCallLoading={setTempDisable}
        />
      </div>
    </div>
  );
}

function FeatureLinkedTopSection(props: {
  featureInstanceData: any;
  actions: TFetureDetailUpdateAction;
  disabled: boolean;
}) {
  const { featureInstanceData, actions, disabled } = props;
  const [tempDisable, setTempDisable] = useState(false);
  const {
    columnHeaders: { bidPackageHeaderMap }
  } = useContext(ProjectContext);

  const governingSource: TGoverningSource | undefined = useMemo(() => {
    const governingTask = (
      featureInstanceData?.links_as_source as Array<any>
    )?.find((x) => x.governing_link);

    if (governingTask) {
      return {
        id: governingTask.target_feature_instance.feature_workflow_instance
          .feature_instance_id,
        name: governingTask.target_feature_instance.title,
        type: getTypeOfGoverningSourceTitle(
          governingTask.target_feature_instance.feature_type_id
        ),
        isLinkedEndDate: governingTask.link_type === 2
      };
    }
    if (featureInstanceData?.feature_workflow_instance?.manual_entry_date) {
      return {
        id: featureInstanceData.feature_workflow_instance.feature_instance_id,
        name: "Manually Set Date",
        type: "Manually Set Date"
      };
    }
    return undefined;
  }, [featureInstanceData]);

  return (
    <Card
      title={
        <HeadingDateBlock
          actions={actions}
          featureInstanceData={featureInstanceData}
          disable={tempDisable}
          setTempDisable={setTempDisable}
        />
      }
      bodyStyle={{ padding: 0 }}
      className="ciq-card-block"
    >
      <div className="w-full h-[470px] flex pl-6">
        <div className="w-[200px] shrink-0 border-0 border-r border-solid border-ciq-gray-300">
          <ErrorBoundary>
            <FeatureToFeatureLinksViewPanel
              featureId={featureInstanceData?.id}
            />
          </ErrorBoundary>
        </div>
        <div className="grow h-full overflow-auto border-0 border-r border-solid border-ciq-gray-300">
          <div className="overflow-auto px-1 flex h-full items-center">
            <ErrorBoundary>
              <EntityDateblock
                entity={featureInstanceData}
                afterChange={() => {
                  actions.refetchFeatureInstanceData();
                }}
                governingSource={governingSource}
                permissions={
                  tempDisable
                    ? {}
                    : {
                        canEditActualDate: !disabled,
                        canEditProjectedDate: !disabled,
                        canEditDurations: !disabled,
                        canEditPlannedDate: !disabled
                      }
                }
                setApiCallLoading={setTempDisable}
                entityHeaders={bidPackageHeaderMap}
              />
            </ErrorBoundary>
          </div>
        </div>
        <div className="w-[300px] shrink-0 overflow-y-auto">
          <ErrorBoundary>
            <BidPackagePlanPanel
              disabled={disabled}
              refetchFeatureInstanceData={actions.refetchFeatureInstanceData}
            />
          </ErrorBoundary>
        </div>
      </div>
    </Card>
  );
}

export default FeatureLinkedTopSection;
